export default "__VITE_ASSET__DCq4swSt__"